export const API = "http://guns.rurik.ru/api/";
export const TOKEN = localStorage.getItem("token");
export const YOUTUBE_API_KEY = "AIzaSyCCsX9QHmqE3rPuctXG1qtJWAHmCYPnqPQ";
export const YOUTUBE_API = "https://www.googleapis.com/youtube/v3/";
export const root = document.querySelector("#root");
export const smoothboreCategoryURL = "smoothbore";
export const rifledCategoryURL = "rifled";
export const overlay = document.querySelector(".overlay");

// Удалить вручную детий удаленных родителей
// Переделать метод удаления , что бы удалял сначала детей, а потом
